module.exports = __webpack_public_path__ + "media/66_Long.bdf9ded2.mp3";